export enum TenantType {
    ATTORNEY = 'ATTORNEY',
    TPO = 'TPO',
    PROVIDER = 'PROVIDER',
    INTERNAL = 'INTERNAL',
    ONBOARDING = 'ONBOARDING',
}

export enum TenantTools {
    AUDIT_MANAGEMENT_TOOL = 'AUDIT_MANAGEMENT_TOOL',
    MANUAL_UPLOAD_TOOL = 'MANUAL_UPLOAD_TOOL',
    RECORD_REQUEST = 'RECORD_REQUEST',
    REQUEST_QUEUE = 'REQUEST_QUEUE',
    REQUEST_MANAGER = 'REQUEST_MANAGER',
}

export enum UserRole {
    ADMIN = 'ADMIN',
    USER = 'USER',
}
